import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@/shared/ui';
import { ResizeHandleWithRef } from './ResizeHandleWithRef';

type Props = {
  /** Блок данных о диалоге скрыт — его ширина сведена к нулю. */
  isDataHidden: boolean;
};

/**
 * Граница блока данных о диалоге: перетаскиванием меняет его размер, убирает с экрана и возвращает.
 *
 * Названа тем, что ею можно сделать сейчас: у видимого блока — изменить размер или скрыть,
 * у скрытого — показать, потому что граница остаётся единственным способом его вернуть.
 *
 * Граница вытянута во всю высоту панели, поэтому подсказка показывается у места наведения:
 * у края она встала бы в стороне от указателя, которым на границу навели.
 */
export const DialogDataResizeHandle: FC<Props> = ({ isDataHidden }) => {
  const { t } = useTranslation(['dialogs']);

  const label = isDataHidden ? t('dialogs:showDialogData') : t('dialogs:resizeOrHideDialogData');

  return (
    <Tooltip tooltip={label} atPointer>
      <ResizeHandleWithRef withHandle aria-label={label} />
    </Tooltip>
  );
};
